export const ERROR_SERVER_SIDE_JOB_ADS = "error_server_side_job_ads"

export const JOB_ADS_QUERY_KEY = "jobAds"

export const JOB_ADS_STATE_QUERY_KEY = "jobAds::savedState"
export const JOB_ADS_STATE_ENDPOINT = "/jobteaser.feedbox.v1alpha1/FeedboxService/GetStateFlag"
export const JOB_ADS_STATE_VALUE = {
  APPLIED: "POST_STATE_APPLIED",
  NONE: "POST_STATE_NONE",
  SAVED: "POST_STATE_SAVED",
} as const

export const GET_USER_RECENT_SEARCHES_QUERY_KEY = "GET_USER_RECENT_SEARCHES_QUERY_KEY"
export const GET_USER_SAVED_SEARCHES_QUERY_KEY = "GET_USER_SAVED_SEARCHES_QUERY_KEY"
export const GET_USER_SAVED_SEARCHES_ENDPOINT = "/jobteaser.job_ad.v2alpha2/SavedSearchService/ListUserSavedSearches"
export const ADD_USER_SAVED_SEARCH_QUERY_KEY = "ADD_USER_SAVED_SEARCH_QUERY_KEY"
export const ADD_USER_SAVED_SEARCH_ENDPOINT = "/jobteaser.job_ad.v2alpha2/SavedSearchService/UpsertSavedSearch"
export const DELETE_USER_SAVED_SEARCH_QUERY_KEY = "DELETE_USER_SAVED_SEARCH_QUERY_KEY"
export const DELETE_USER_SAVED_SEARCH_ENDPOINT = "/jobteaser.job_ad.v2alpha2/SavedSearchService/DeleteSavedSearch"

export const JOB_ADS_CANDIDACY_TYPES = {
  EMAIL: "EMAIL",
  EXTERNAL: "EXTERNAL",
  INTERNAL: "INTERNAL",
  UNKNOW: "UNKNOWN",
} as const

export const CREATE_RSS_FEED_LINK_ENDPOINT = "/rss/create"
